import { TableInsertModel, TableRowModel, TableUpdateModel } from '@examdojo/supabase';

export type AssessmentTL2RelationshipHttpModel = Pick<
  TableRowModel<'assessments_topics_level_02', 'learning'>,
  'assessment_id' | 'topic_level_02_id'
>;

export type AssessmentTL2RelationshipStoreModel = AssessmentTL2RelationshipHttpModel & {
  id: `${AssessmentTL2RelationshipHttpModel['assessment_id']}-${AssessmentTL2RelationshipHttpModel['topic_level_02_id']}`;
};

export type AssessmentTL2RelationshipUIModel = AssessmentTL2RelationshipStoreModel;

export const ASSESSMENT_TL2_RELATIONSHIP_CREATE_ALLOWED_KEYS = ['assessment_id', 'topic_level_02_id'] satisfies Array<
  keyof TableInsertModel<'assessments_topics_level_02', 'learning'>
>;

export type AssessmentTL2RelationshipCreateModel = Pick<
  TableInsertModel<'assessments_topics_level_02', 'learning'>,
  (typeof ASSESSMENT_TL2_RELATIONSHIP_CREATE_ALLOWED_KEYS)[number]
>;

export const ASSESSMENT_TL2_RELATIONSHIP_UPDATE_ALLOWED_KEYS = [
  ...ASSESSMENT_TL2_RELATIONSHIP_CREATE_ALLOWED_KEYS,
] satisfies Array<keyof TableUpdateModel<'assessments_topics_level_02', 'learning'>>;

export type AssessmentTL2RelationshipUpdateModel = Pick<
  TableUpdateModel<'assessments_topics_level_02', 'learning'>,
  (typeof ASSESSMENT_TL2_RELATIONSHIP_UPDATE_ALLOWED_KEYS)[number]
>;
